import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhom() {
  const forYou = ['Mujeres de más de 40 años que sienten que su cuerpo ya no responde a la dieta convencional.', 'Quienes sufren de inflamación abdominal que empeora durante el día.', 'Mujeres bajo mucho estrés que no logran descansar bien.', 'Aquellas que buscan una solución natural, práctica y basada en la salud hormonal.'];
  const notForYou = ['Quienes buscan una "pastilla mágica" sin cambiar un solo hábito alimenticio.', 'Personas que buscan consejos médicos o quirúrgicos para la pérdida de grasa.', 'Mujeres que no están dispuestas a eliminar los inflamadores procesados durante 7 días.'];
  return <SectionWrapper data-id="element-70">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-71">
        {/* Para ti */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-72">
          <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center" data-id="element-73">
            <span className="bg-green-100 text-green-700 p-2 rounded-full mr-3" data-id="element-74">
              <CheckIcon className="w-6 h-6" data-id="element-75" />
            </span>
            Para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-76">
            {forYou.map((item, i) => <li key={i} className="flex items-start space-x-3 text-gray-700" data-id="element-77">
                <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-78" />
                <span data-id="element-79">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* No es para ti */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-80">
          <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center" data-id="element-81">
            <span className="bg-red-100 text-red-700 p-2 rounded-full mr-3" data-id="element-82">
              <XIcon className="w-6 h-6" data-id="element-83" />
            </span>
            No es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-84">
            {notForYou.map((item, i) => <li key={i} className="flex items-start space-x-3 text-gray-700" data-id="element-85">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-86" />
                <span data-id="element-87">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </SectionWrapper>;
}